/**
 * Auto-découvert par `apps/web/src/routes/modules.ts` via :
 *   import.meta.glob('../../../../modules/*\/web/route.tsx', { eager: true })
 *
 * Module Fournisseurs (GO Ben 22/08, `ANALYSE-FOURNISSEURS-CONFIG.md` bloc
 * 🎯) — fiche fournisseur v1 : identité miroir Presta lecture seule +
 * contacts à rôles + notes (langue RETIRÉE du périmètre v1, décision Ben
 * 22/08). Réservé admin côté API
 * (`apps/api/src/config/acces.ts`) et masqué côté onglet pour les non-admins
 * (`apps/web/src/lib/acces.ts`).
 *
 * 2 routes top-level, même pattern que `herbo-lot-detail`/
 * `herbo-commande-labo-tiers` (liste visible + fiche `:idSupplier` cachée —
 * pas de point d'atterrissage valide sans id connu).
 */
import { lazy, Suspense, type ReactNode } from 'react';
import type { ModuleRoute } from '@herbo/module-route';

const FournisseursListePage = lazy(() => import('./pages/FournisseursListe'));
const FournisseurFichePage = lazy(() => import('./pages/FournisseurFiche'));

function Chargement({ label }: { label: string }): ReactNode {
  return (
    <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
      {label}
    </div>
  );
}

const listeRoute: ModuleRoute = {
  path: 'fournisseurs',
  label: 'Fournisseurs',
  icon: 'truck',
  element: (
    <Suspense fallback={<Chargement label="Chargement des fournisseurs…" />}>
      <FournisseursListePage />
    </Suspense>
  ),
};

const ficheRoute: ModuleRoute = {
  path: 'fournisseurs/:idSupplier',
  label: 'Fournisseur',
  icon: 'truck',
  hidden: true,
  element: (
    <Suspense fallback={<Chargement label="Chargement du fournisseur…" />}>
      <FournisseurFichePage />
    </Suspense>
  ),
};

export default [listeRoute, ficheRoute];
